import moment from 'moment-timezone';

export const lastDateFromMonth = (year, month) => {
  // Note that month starts with 0, therefore we don't need to + 1 here
  if (year && month) {
    return new Date(year, month, 0).getDate();
  }
  return null;
};

export function nextNDayJPs(numberOfDays) {
  let arrayOfDays = [];
  let nextDays = nextNDays(numberOfDays);
  for (let index = 0; index < numberOfDays; index++) {
    let monthElement = {
      value: nextDays[index].toDate().getTime(),
      text: yearMonthDayJP(nextDays[index].format('YYYY/MM/DD')),
    };
    arrayOfDays.push(monthElement);
  }
  return arrayOfDays;
}

export function nextNDays(numberOfDays) {
  let arrayOfDays = [];
  for (let index = 0; index < numberOfDays; index++) {
    let timestamp = moment()
      .add(index + 1, 'days')
      .startOf('day');
    arrayOfDays.push(timestamp);
  }
  return arrayOfDays;
}

export function currentDayJP() {
  return {
    value: moment().toDate().getTime(),
    text: moment().format('YYYY年MM月DD日'),
  };
}

export function previousNDayJPs(numberOfDays) {
  let arrayOfDays = [];
  let previousDays = previousNDays(numberOfDays);
  for (let index = 0; index < numberOfDays; index++) {
    let monthElement = {
      value: previousDays[index].toDate().getTime(),
      text: yearMonthDayJP(previousDays[index].format('YYYY/MM/DD')),
    };
    arrayOfDays.push(monthElement);
  }
  return arrayOfDays;
}

export function previousNDays(numberOfDays) {
  let arrayOfDays = [];
  for (let index = 0; index < numberOfDays; index++) {
    let timestamp = moment()
      .subtract(index + 1, 'days')
      .startOf('day');
    arrayOfDays.push(timestamp);
  }
  return arrayOfDays;
}

export function yearMonthDayJP(yearSlashMonth) {
  let yearMonthArray = yearSlashMonth.split('/');
  try {
    let year = yearMonthArray[0];
    let month = yearMonthArray[1];
    let date = yearMonthArray[2];
    return year + '年' + month + '月' + date + '日';
  } catch (error) {
    return '';
  }
}

export function secondsDiff(date1, date2) {
  if (date1 && date2) {
    return moment(date2).diff(moment(date1), 'seconds');
  }
  return 0;
}
